import { z } from 'zod'

import { HouseShipmentSchema } from '../domain/houseShipment.ts'
import { OverviewItem, OverviewItemSchema } from '../domain/overviewItem.ts'
import { CustomerHouseShipmentResponse } from '../types.ts'
import {
  getPlaceOfDeliveryNode,
  getPlaceOfPickupNode,
  getShipmentDelay,
  getTimelineData,
} from '../utils/getTimelineData.ts'

export const unifiedShipmentToOverviewItem = (
  shipment: CustomerHouseShipmentResponse,
  hasCustoms = false
): OverviewItem | undefined => {
  try {
    const houseShipment = HouseShipmentSchema.parse(shipment)
    const { delayDays, basis: delayBasis } = getShipmentDelay(houseShipment)
    const parsingObj = {
      id: houseShipment.code,
      type: 'shipment',
      transportMode: houseShipment.details.mainTransportMode,
      transportType: houseShipment.details.mainTransportType,
      containerQuantity: houseShipment.houseCargos.length,
      state: houseShipment.status,
      bookedDate: houseShipment.details.bookedAt,
      createdDate: houseShipment.sys.createdAt,
      deliveryDate: getPlaceOfDeliveryNode(houseShipment)?.milestones.timeOfArrival?.timeStampUTC,
      pickupDate: getPlaceOfPickupNode(houseShipment)?.milestones.timeOfDeparture?.timeStampUTC,
      timeline: getTimelineData(houseShipment),
      containerPlans: [], // do not have
      customerReference: houseShipment.details.customerReference || '',
      shipper: houseShipment.contacts.shipperContactName || '',
      consignee: houseShipment.contacts.consigneeContactName || '',
      cargo: [], // deprecated by houseCargos
      houseCargos: houseShipment.houseCargos,
      delayDays,
      delayBasis,
      additionalID: houseShipment.details.bookingID,
      // Comes from searchlight: the indexed shipment does not carry the customs items to derive it from
      hasCustoms,
    }

    return OverviewItemSchema.parse(parsingObj)
  } catch (error) {
    /* eslint-disable no-console */
    if (error instanceof z.ZodError) {
      console.error(`ZOD Error in shipmentV2ToOverviewItem: ${shipment.code}`, error.issues)
    } else {
      console.error(`Error in shipmentV2ToOverviewItem: ${shipment.code}`, error)
    }
  }
}
